import React from 'react';

import { LoginLayout } from '../../components/login/index.troy';
import { ZipCodeForm } from '../../components/zip-code/index.troy';

import { validateZipCode } from '../../actions';

import { connectTo } from '../../utils';

class ZipCodeValidationPage extends React.Component {
  onValidate = (zipCode) => {
    const { token, validateZipCode } = this.props;
    validateZipCode({ zipCode, token });
  };

  render() {
    const { status, attemptsAllowed, attemptsLeft } = this.props;
    return (
      <LoginLayout>
        <ZipCodeForm
          onSubmit={this.onValidate}
          {...{ status, attemptsAllowed, attemptsLeft }}
        />
      </LoginLayout>
    );
  }
}

export default connectTo(
  ({ zipCode: { status, attemptsAllowed, attemptsLeft } }) => ({
    status,
    attemptsAllowed,
    attemptsLeft,
  }),
  { validateZipCode },
  ZipCodeValidationPage
);
